import React, { useEffect, useRef, useState } from 'react';
import Layout from '../Layout';
import { Image } from 'react-bootstrap';
import Carousel from "../components/Carousel";
import 'animate.css';
import { Link } from "react-router-dom";

const Home = () => {

    const ref = useRef(null);
    const [inView, setInView] = useState(false);

    return (
        <Layout>

            <Carousel/>


            {/* <section className='carousel-container'>
                <div className='carousel-content-one'>
                    <Image src="/img-header.png"
                        alt="Hero"
                        className="img-fluid hero-img"
                    />
                </div>
                <div className='carousel-content-two'>
                    <div className='carousel-text-content'>
                        <h1 className="carousel-text-h1 wow animate__animated animate__fadeInUp" data-wow-duration="1s">Building Resilient Communities and Transforming Lives</h1>
                        <div className=''>
                            <p className="carousel-text-p wow animate__animated animate__fadeInUp" data-wow-duration="1.8s">We continuously seek innovative ways to enhance our service offerings and operational efficiency.</p>
                            <div className='d-flex gap-3 mt-4'>

                                <button className='cta btnFill wow animate__animated animate__fadeInUp' data-wow-duration='2.5s'>Donate Now</button>
                                <button className='btnBorder wow animate__animated animate__fadeInUp' data-wow-duration='2.5s'>Join our mission</button>
                            </div>
                        </div>
                    </div>
                </div>
            </section> */}


            {/* <section className='progress-container'>

                <div className="justify-content-center bg-white text-center wow animate__animated animate__fadeInUp" data-wow-duration="1.2s">
                    <h3 className="h2 fw-bold">30K +</h3>
                    <p className="text-m text-mute">Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                </div>
                <div className=" justify-content-center bg-white text-center  wow animate__animated animate__fadeInUp" data-wow-duration="1.5s">
                    <h3 className="h2 fw-bold">3,200</h3>
                    <p className="text-m text-mute">Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                </div>
                <div className=" justify-content-center bg-white text-center wow animate__animated animate__fadeInUp" data-wow-duration="2s">
                    <h3 className="h2 fw-bold">100</h3>
                    <p className="text-m text-mute">Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                </div>

            </section> */}


            <section className='section'>
                <div className='lineOne  wow animate__animated animate__fadeInLeft' data-wow-duration="1.5s" />
            </section>


            <section className='section-container'>

                <div className='gap-5 align-items-end'>
                    <div className='secOne'>
                        <h1 className="wow animate__animated animate__fadeInUp" data-wow-duration="1.4s">Welcome to Bethel <br />Community Foundation Canada</h1>
                    </div>
                    <div className='secTwo'>
                        <p className="paragraph-title wow animate__animated animate__fadeInUp" data-wow-duration="1.5s">Bethel Community Foundation Canada (BCFC) is a registered not-for-profit charity based in Alberta, dedicated to enriching the lives of vulnerable and underserved communities. Our organization is powered by a passionate network of professionals and grassroots changemakers who generously contribute their time, experience, and resources to support individuals in need.</p>
                    </div>

                </div>
  
                <div className='img-container'>
                    <div className='img-box wow animate__animated animate__fadeInUp' data-wow-duration="1s">
                        <Image src="/images/img1.png"
                            alt="Hero"
                            className="img-fluid box-img"
                        />
                    </div>
                    <div className='img-boxTwo wow animate__animated animate__fadeInUp' data-wow-duration="1.2s">
                        <Image src="/images/img2.png"
                            alt="Hero"
                            className="img-fluid box-img"
                        />
                    </div>
                </div>

            </section>


            {/* Services Section */}
            <section className="section-container">
                <div className="services-section">
                    <h2 className="h4 mb-3 text-center wow animate__animated animate__fadeInUp" data-wow-duration="1s">From mentoring young adults to providing shelter for displaced individuals, BCFC offers lifelines of hope and empowerment.</h2>
                    <div className="mb-4 w50">
                        <p className="mb-4 text-center wow animate__animated animate__fadeInUp paragraph" data-wow-duration="1.4s">
                            Whether through outreach programs, support services, or community development initiatives, our commitment is rooted in compassion, inclusivity, and actionable change.
                        </p>
                    </div>
                </div>
                <div className="serv-imgBox">
                    <div className='wow animate__animated animate__fadeInUp' data-wow-duration="1.2s">
                        <Image src="/images/img3.png" alt="Elderly" className="img-fluid" />
                    </div>
                    <div className='hide wow animate__animated animate__fadeInUp' data-wow-duration="1.5s">
                        <Image src="/images/img4.png" alt="Youth" className="img-fluid servImg" />
                    </div>
                    <div className='hide wow animate__animated animate__fadeInUp' data-wow-duration="1.8s">
                        <Image src="/images/img5.png" alt="Settlement" className="img-fluid servImg" />
                    </div>
                </div>
            </section>

            <section className=" whatWeDo">

                <div className="whatWeDo-top">

                    <div className="whatWeDo-content">
                        <h2 className="h4 mb-3 wow animate__animated animate__fadeInUp" data-wow-duration="1s">Our core services are carefully designed to meet the diverse and pressing needs of BIPOC communities across.</h2>
                    </div>

                    <div className="whatWeDo-btns wow animate__animated animate__fadeInUp" data-wow-duration="1s">
                        <Link to="/Program&Services">
                        <button className="btn btn-primary">View more services</button>
                        </Link>
                    </div>

                 </div>

                <div className="whatWeDo-bottom">
                    <div className="serv-box  wow animate__animated animate__fadeInUp" data-wow-duration="1.2s">
                        <Image src="/images/img6.png" alt="Hero" className="img-fluid serv-img rond"/>
                        <div className='serv-box-content'>
                            <h3 className='serv-title'>Elderly & Vulnerable Adults</h3>
                            <ul>
                                <li>Outreach programs for aging BIPOC seniors</li>
                                <li>Wellness visits and social inclusion activities</li>
                            </ul>
                        </div>
                    </div>

                    <div className="serv-box display_one wow animate__animated animate__fadeInUp" data-wow-duration="1.4s">
                        <div className='serv-box-content'>
                            <h3 className='serv-title'>Youth & Young Adults</h3>
                            <ul>
                                <li>Mentorship programs focused on personal growth and leadership</li>
                                <li>Literacy and skills development workshops</li>
                            </ul>
                        </div>
                        <Image src="/images/img7.png" alt="Hero" className="img-fluid serv-img rond"/>
                    </div>
                    
                    <div className="serv-box wow animate__animated animate__fadeInUp" data-wow-duration="1.8s">
                        <Image src="/images/img8.png"  alt="Hero" className="img-fluid serv-img rond"/>
                        <div className='serv-box-content'>
                            <h3 className='serv-title'>Settlement & Integration Support</h3>
                            <ul>
                                <li>Airport pickup and transitional support.</li>
                                <li>Coaching for interviews and transportation logistics</li>
                            </ul>
                        </div>
                    </div>

                </div>

            </section>

            <section className="section-container">
                <div className="services-section">
                    <h2 className="h4 mb-3 text-center px-5  wow animate__animated animate__fadeInUp" data-wow-duration="1s">Join us in building resilient communities<br/> and transforming lives<br />— one initiative at a time —</h2>
                    <div className="mb-4 text-center">
                        <h1 className="numb mb-4 mx-auto text-center px-5  wow animate__animated animate__fadeInUp" data-wow-duration="1.2s">
                            3,200+
                        </h1>
                        <p className="paragraph-title text-center wow animate__animated animate__fadeInUp" data-wow-duration="1.4s">have already joined</p>
                        <button className="btn btn-primary btn-mission  wow animate__animated animate__fadeInUp" data-wow-duration="1.5s">Join Our Community</button>
                    </div>
                    
                </div>
            </section>



        </Layout>
    );
};

export default Home;